import type { Params } from '@angular/router'

const trackingQueryParamKeys = new Set([
  'aw_ids',
  'uid',
  'ajs_user_id',
  'obclid',
  'fbclid',
  'fbc',
  'fbp',
  'li_fat_id',
  'msclkid',
  'auctid',
  'vwo_uuid',
  'gclid',
  'ga4id',
  'ga_sessid',
  'ga_sessnum',
  'via',
  'ttclid',
  'ttp'
])

/**
 * Builds the the marketing properties event data from the aw_url cookie or url
 * @param {
 *  url: string,
 *  awUrlCookie: string
 * }
 * @returns {Record<string, string>}
 */
export function buildMarketingPropertiesFromAwUrlCookieOrUrl({
  url,
  awUrlCookie
}: Partial<{
  url: string
  awUrlCookie: string
}>): Record<string, string> {
  const source = awUrlCookie ?? url

  if (!source) {
    return {}
  }

  try {
    const sourceSearchParams = new URLSearchParams(new URL(source).search)

    const result = {}

    for (const [key, value] of sourceSearchParams.entries()) {
      result[key] = value
    }

    return result
  } catch (_) {
    return {}
  }
}

/**
 * Removes tracking query parameters after they have been read into tracking cookies.
 * @param {URLSearchParams} searchParams
 * @returns {Params}
 */
export function buildQueryParamsWithoutTrackingParams(searchParams: URLSearchParams): Params {
  const queryParams: Params = {}

  for (const [key, value] of searchParams.entries()) {
    if (!trackingQueryParamKeys.has(key)) {
      queryParams[key] = value
    }
  }

  return queryParams
}

/**
 * Checks whether the URL params contain a tracking parameter.
 * @param {URLSearchParams} searchParams
 * @returns {boolean}
 */
export function hasTrackingQueryParams(searchParams: URLSearchParams): boolean {
  for (const key of trackingQueryParamKeys) {
    if (searchParams.has(key)) {
      return true
    }
  }

  return false
}
